import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getCampaignList = async (param) => {
  const baseUrl = `${API_CONSTANTS.GAMIFICATION}/campaigns`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const getCampaignDetail = async (id) => {
  let url = `${API_CONSTANTS.GAMIFICATION}/campaigns/detail?id=${Number(id)}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const deactivateCampaign = async (id) => {
  let url = `${API_CONSTANTS.GAMIFICATION}/campaigns/delete?id=${Number(id)}`;
  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const createCampaign = async (formData) => {
  const url = `${API_CONSTANTS.GAMIFICATION}/campaigns`;
  let responseObj = await dataAccess.upload(url, { data: formData });
  return responseObj;
};

// CAMP-07: PUT /campaigns/update?id=<campaignId> — id is a query param, not a
// body field (API-CONTRACT.md §4), mirroring updateVoucher(id, ...)'s
// `?id=${id}` convention already used elsewhere in this codebase.
export const updateCampaign = async (id, formData) => {
  const url = `${API_CONSTANTS.GAMIFICATION}/campaigns/update?id=${Number(id)}`;
  let responseObj = await dataAccess.update(url, { data: formData });
  return responseObj;
};
